<div id="drawerTopRef" class="drawer-container" [ngClass]="rootClassName">
  <div class="drawer-content-container" [ngClass]="isEmpty(headerState) ? 'rounded-sm' : 'rounded'">
    @if (isHandlebarVisible) {
      <pop-ui-handlebar (action)="onHandlebarAction($event)"></pop-ui-handlebar>
    }
    <pop-ui-drawer-header [(state)]="headerState" class="drawer-header" [ngClass]="{center: !isControlOnly}"></pop-ui-drawer-header>
    <div [ngClass]="{'frame16pxspacer':isEmpty(headerState)}"></div>
    <pop-ui-drawer-content [(state)]="state" class="drawer-content" [ngClass]="{scrollable: isContentScroll}"></pop-ui-drawer-content>
  </div>
</div>
